import { useSelector } from "react-redux";

import { MAGICO_CONFIG_KEYS } from "../constants";
import { selectAppConfigs } from "../store/slices/appConfig";
import { readConfigFlag } from "../utilities/magicoConfig";

/**
 * Whether the "players finished" count may be rendered. `hide_players_count` is a hide
 * flag; this is the only place that inversion lives, so callers see a positive boolean.
 * An absent or malformed value keeps the count visible.
 */
export const usePlayersCountVisibility = (): boolean => {
  const configs = useSelector(selectAppConfigs);
  return !readConfigFlag(configs[MAGICO_CONFIG_KEYS.HIDE_PLAYERS_COUNT]);
};
